<template>
  <div class="el-section">
    <div class="emd-container">
      <div class="emd-container__header eu-py_4_md eu-px_5_md">
        <h2 class="emd-text _size_section _color_default">
          {{ $t("title") }}
        </h2>
      </div>
      <hr class="emd-divider" />
      <div class="emd-container__content eu-pa_5_md">
        <emd-alert
          v-if="tabbarError.status"
          variant="danger"
          :title="`${$t('tabbarError')}`"
          @cancel="tabbarError.status = false"
          autoclose
        />
        <div
          class="emd-spotlight-list"
          :class="{ '_has-selected': !paymentSelected }"
        >
          <div class="eu-flex eu-my_5">
            <div
              class="eu-flex-item eu-basis_12 eu-mb_3 eu-no-margin_md"
              v-for="(item, index) in paymentMethodItems"
              :key="index"
              :class="shouldsSetPixPaymentMethodClass"
            >
              <div
                class="emd-spotlight-list__item emd-container _type_card _content_stretch eu-display_flex _actionable eu-pa_4"
                :class="{
                  '_active _selected': item.title === selectedPaymentMethod,
                }"
                @click="selectPaymentMethod(item.title)"
              >
                <div
                  class="emd-container__header eu-pa_3 emd-text _color_subtle"
                  :class="{
                    _color_tertiary: item.title === selectedPaymentMethod,
                  }"
                >
                  <i
                    class="emd-text _size_page"
                    :class="['uil', item.icon]"
                  ></i>
                </div>
                <div
                  class="emd-container__content eu-basis_auto eu-display_flex eu-align-items_center"
                >
                  <p class="emd-text _type_caption">
                    {{ $t(item.title) }}
                  </p>
                  <div
                    class="emd-highlight-tag _bottom _color_tertiary"
                    :class="{ _active: item.title === selectedPaymentMethod }"
                  >
                    <span class="eu-position_relative">
                      <i class="uil uil-check"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="el-section">
      <div class="eu-display_flex eu-justify_space-between eu-wrap_reverse">
        <button
          class="emd-btn _color_secondary _type_text _block_mobile"
          @click="reverseRoute"
        >
          <i class="uil uil-angle-left"></i>
          {{ $t("orderData") }}
        </button>
        <button
          class="emd-btn _color_secondary _block_mobile eu-mb_5 eu-no-margin_sm"
          @click="nextRoute"
          :disabled="paymentSelected"
        >
          {{ $t("customer") }}
          <i class="uil uil-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EmdAlert from '@/components/emerald/molecules/EmdAlert'

export default {
  name: 'PaymentMethod',
  data () {
    return {
      initialPaymentMethod: '',
      initialPaymentRoute: '',
      initialPaymentRoutePermission: ''
    }
  },
  components: {
    EmdAlert
  },
  beforeMount () {
    this.initialPaymentMethod = this.selectedPaymentMethod
    this.initialPaymentRoute = null
    this.initialPaymentRoutePermission = this.routesWizard.find(
      (item) => item.path === 'payment'
    ).permission
    this.$store.dispatch('RESET_BILLING_ADDRESS_FLAGS')
  },
  computed: {
    ...mapGetters({
      selectedPaymentType: 'selectedPaymentType',
      selectedPaymentMethod: 'selectedPaymentMethod',
      paymentMethodsEnabled: 'paymentMethodsEnabled',
      paymentMethodItemsGetter: 'paymentMethodItems',
      paymentSelected: 'paymentSelected',
      tabbarError: 'tabbarError',
      routesWizard: 'routesWizard',
      addressGetter: 'address'
    }),
    isTypedSale () {
      return this.selectedPaymentType === 'typed-sale'
    },
    paymentMethodItems () {
      return this.paymentMethodItemsGetter.filter((item) => this.paymentMethodsEnabled.includes(item.title)).filter(item => !(item.title === 'checkout' && this.isTypedSale))
    },
    paymentSelected () {
      return this.selectedPaymentMethod === ''
    },
    address () {
      return this.addressGetters.show_address
    },
    shouldsSetPixPaymentMethodClass () {
      const paymentMethods = this.paymentMethodItems.map((item) => item.title)
      return paymentMethods.length > 3 ? 'eu-basis_3_md' : 'eu-basis_4_md'
    }
  },
  methods: {
    selectPaymentMethod (value) {
      this.paymentSelected = false
      this.$store.dispatch('SET_PAYMENT_METHOD', value)
      this.setPermissionToPaymentData()
      this.blockLastRoute()
    },
    setPermissionToPaymentData () {
      if (this.initialPaymentRoutePermission) {
        this.routesWizard = this.routesWizard.map((item) => {
          if (item.path === 'payment') {
            this.initialPaymentRoute = this.initialPaymentRoute
              ? item.permission
              : this.initialPaymentRoute
            item.permission = !(
              this.selectedPaymentMethod === 'boleto' && !this.address
            )
          }
        })
      }
    },
    blockLastRoute () {
      if (
        this.selectedPaymentMethod !== this.initialPaymentMethod &&
        this.selectedPaymentMethod.length
      ) {
        this.$store.dispatch('RESET_PAYMENT_STATE', false)
        this.routesWizard.map((item) => {
          if (item.path === 'review') item.permission = false
        })
      }
    },
    nextRoute () {
      this.$router.push({ name: 'Customer' })
    },
    reverseRoute () {
      this.$router.push({ name: 'Items' })
    }
  },
  watch: {
    paymentSelected: {
      handler: function () {
        this.$store.dispatch('SET_PERMISSION', {
          status: this.paymentSelected,
          component: this.$route.name,
          paymentType: this.selectedPaymentType
        })
        this.tabbarError.status = false
      }
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Como deseja fazer a cobrança?",
      "checkout": "Gerar Link de Pagamento",
      "boleto": "Gerar Boleto",
      "credit_card": "Pagar com cartão de crédito",
      "pix": "Pagar com Pix",
      "orderData": "Dados do pedido",
      "customer": "Dados do cliente",
      "tabbarError": "É necessário selecionar um tipo de cobrança."
    },
    "en-US": {
      "title": "How you wish to charge?",
      "checkout": "Generate Payment Link",
      "boleto": "Generate boleto",
      "credit_card": "Pay with credit card",
      "pix": "Pay with Pix",
      "orderData": "Order Items",
      "customer": "Customer",
      "tabbarError": "A payment method is required."
    }
  }
</i18n>
